import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  container: {
    height: 'calc(100vh - 83px)',
    display: 'flex',
    padding: '8px 8px'
  },
  headerGrid: {
    height: 88,
    boxSizing: 'border-box',
  },
  headerRow: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    marginBottom: 20,
  },
  dealReviewDetailsParent: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: 0,
    gap: '20px'
  },
  dealReviewDetails: {
    maxHeight: 'clamp(450px, calc(100vh - 500px), 900px)',
    overflowY: 'scroll',
    overflowX: 'hidden'
  },
  dealReviewFooter: {
    position: 'sticky',
    bottom: 0,
    zIndex: 2,
    flexShrink: 0,
    backgroundColor: '#fff',
    // borderTop: '1px solid #E0E0E0',
  },
  '@media (max-width: 1200px)': {
    dealReviewDetailsParent: {
      gap: '12px',
    },
    dealReviewDetails: {
      maxHeight: '50vh',
    },
  },
}));

export default useStyles;